import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import siteContent from '../../content/site/content.json';

const getIcon = (name) => {
  const Icon = Icons[name];
  return Icon ? <Icon className="w-5 h-5" /> : null;
};

// Compact homepage problem bridge — icon bullets + one sentence.
// The full challenge breakdown lives on /residents.
const ProblemBridge = () => {
  const d = siteContent.challenge;
  const items = (d.challenges || []).slice(0, 3);

  return (
    <section id="challenge" className="py-14 lg:py-16 bg-white scroll-mt-20" data-testid="problem-bridge-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-2xl sm:text-3xl font-bold text-[#1F1E1E] leading-tight mb-3">
          {d.heading}
        </h2>
        <p className="text-base text-[#3B3535]/70 max-w-2xl mx-auto mb-8">
          Repairs drag on, evidence gets scattered, and every conversation starts from scratch.
        </p>
        <Link
          to="/residents"
          data-testid="problem-bridge-more-link"
          className="block group"
        >
          <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 mb-6">
            {items.map((c, i) => (
              <span
                key={i}
                data-testid={`problem-item-${i}`}
                className="inline-flex items-center justify-center gap-2.5 bg-[#FFF8F5] border border-[#B5541B]/10 group-hover:border-[#B5541B]/30 rounded-full px-5 py-3 text-sm font-semibold text-[#1F1E1E] transition-colors"
              >
                <span className="text-[#B5541B]">{getIcon(c.icon)}</span>
                {c.title}
              </span>
            ))}
          </div>
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#B5541B] group-hover:text-[#8B3F14] transition-colors">
            See how ResiAX keeps your housing story together
            <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
          </span>
        </Link>
      </div>
    </section>
  );
};

export default ProblemBridge;
